import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from '@/types/store';

export declare namespace PackageTypes {
    /**
     * rmb-人民币
     * intrgral-积分
     * intrgral_rmb-积分+人民币
     */
    // type PackageType = "rmb" | "intrgral" | "intrgral_rmb";
    // interface PackageSelect extends Activity.Package {
    //     id: number
    //     type: PackageType
    //     name: string
    //     image: string
    //     detail_image: string
    //     price: number
    //     /** 积分 */
    //     intrgral: number
    //     /** 是否禁止选择 */
    //     disabled: boolean
    //     /** 是否允许升级套餐 */
    //     can_change_package: boolean
    // }
}

export interface PackageState {
    selectPackage: {
        [activityId: string]: Activity.Package[]
    }
}

export const packageStore: Module<PackageState, RootState> = {
    namespaced: true,
    state: {
        selectPackage: {}
    },
    mutations: {
        setSelectPackage(state, { list, activityId }) {
            Vue.set(state.selectPackage, activityId, list)
        },
    },
    actions: {
        async getSelectPackage({commit}, { activityId }) {
            const res = await Vue.axios.get('/api/v1/package_gift/package_select', {
                params: {
                    activity_id: activityId
                }
            })
            const rdata = res.data;
            if(rdata.status === 0) {
                commit('setSelectPackage', {
                    list: rdata.data,
                    activityId
                })
            }
            return rdata;
        },
        async packageUpgrade({commit}, { activityId, packageId }) {
            const res = await Vue.axios.post('/api/v1/package_gift/upgrade', {
                activity_id: activityId,
                package_id: packageId
            })
            const rdata = res.data as {
                type: 'upgrade' | 'same',
                order?: {
                    id: string
                }
            };
            return rdata;
        },

    },
};
